import React, { useState, useMemo } from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Table, Modal } from "react-bootstrap";

export const WithdrawalRequestModal = ({
  RequestWithdrawModal,
  handleClose1,
  withdrawSlots,
  increasePrice,
  currentSlots,
  onWithdrawRequest,
  withdrawSettings,
}) => {
  const [data, setData] = useState({
    selectedSlot: -1,
    slot: "",
    price: "",
    tokens: "",
    totalGrams: "",
  });

  const [paymentBy, setPaymentBy] = useState("Gold");

  let slots = useMemo(
    () => withdrawSlots.slots.filter((slot) => !slot.isRedemed),
    [withdrawSlots]
  );

  const onSlotChange = (e, slot, i) => {
    console.log(e.target.checked);
    console.log(slot);
    if (e.target.checked) {
      setData({
        selectedSlot: i,
        slot,
        price: (slot.grams * increasePrice).toFixed(4),
        tokens: slot.tokens,
        totalGrams: slot.goldPartFromGram,
      });
    } else {
      setData({
        selectedSlot: -1,
        slot: "",
        price: "",
        tokens: "",
        totalGrams: "",
      });
    }
  };

  const onWithdrawBtn = () => {
    if (data.selectedSlot !== -1) {
      data.requestTransferMehtod = paymentBy;
      onWithdrawRequest(data);
    }
  };

  return (
    <Modal
      show={RequestWithdrawModal}
      onHide={handleClose1}
      centered
      className="def_modal rqst_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fn_s_18 color_blk f-w-700">
          Request Withdraw
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <h4 className="fn_s_18 f-w-500 color_blk mb-4">
              Select Gold ID from you want to withdraw
            </h4>
            <div className="mt-0">
              <Table hover responsive className="mb-0 default_table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Gold Id</th>
                    <th>Total Gold (GRAMS)</th>
                    <th>Gold Acquired (GRAMS)</th>
                    <th>Cost of Gold/ 1 Gram (USD)</th>
                    <th>Tokens</th>
                    <th>Current Value of Tokens</th>
                  </tr>
                </thead>
                <tbody>
                  {slots.length ? (
                    slots.map((slot, i) => (
                      <tr key={i}>
                        <td>
                          <div className="ap_checkbox tblckcbx">
                            <input
                              id={i}
                              key={i}
                              type="checkbox"
                              name="checkbox"
                              className="mr-2 checkbox"
                              checked={data.selectedSlot === i}
                              value={data.selectedSlot === i}
                              onChange={(e) => onSlotChange(e, slot, i)}
                            />
                            <label></label>
                          </div>
                        </td>
                        <td>{slot.goldPartID}</td>
                        <td>{slot.goldPartFromGram}</td>
                        <td>{slot.grams}</td>
                        <td>{increasePrice}</td>
                        <td>{slot.tokens}</td>
                        <td>{currentSlots.currentToken}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="col-md-12 mt-10">
            <div className="mx-420">
              <form className="form def_form frmwtpddng">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">Withdraw Tokens</label>
                      <input
                        placeholder="Tokens"
                        type="text"
                        className="form-control frrgtpdng120"
                        name="tokens"
                        value={data.tokens}
                        disabled
                      />
                      {/* <div className="mxusd_txt">MAX 12,781 USD</div> */}
                    </div>
                  </div>
                  <div className="col-sm-4 mb-5 text-center">
                    <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      {" "}
                      Charges
                    </label>
                    <h4 className="fn_s_16 f-w-500 color_blk">
                      {withdrawSettings.fixedCharge}&nbsp;&nbsp;
                      {withdrawSettings.chargeType === "PERCENTAGE"
                        ? "%"
                        : withdrawSettings.chargeType === "AMOUNT"
                        ? withdrawSettings.currencyMethod
                        : null}
                    </h4>
                  </div>
                  <div className="col-sm-4 mb-5 text-center">
                    <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Payment By
                    </label>
                    <select
                      className="form-control wtblcar_v2"
                      value={paymentBy}
                      onChange={(e) => setPaymentBy(e.target.value)}
                    >
                      <option value="Gold">Gold</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                    </select>
                    {/* <h4 className="fn_s_16 f-w-500 color_blk">Bank Transfer</h4> */}
                  </div>
                  <div className="col-sm-4 mb-5 text-center">
                    <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      You Get
                    </label>
                    <h4 className="fn_s_16 f-w-500 color_blue">{data.price}</h4>
                  </div>
                  <div className="col-md-12 text-center mt-2">
                    <button
                      type="button"
                      className="btn btn-def btn-defv4 uppercase"
                      onClick={onWithdrawBtn}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
